//gatsby component
import React from "react";

import {
    uncollapsed,
    collapsed,
    accordion,
    accordionPanel,
    arrow,
    padB30
} from "./main.module.scss";

const Faqs = ({questions, answers}) => {

    const [accordionStatus, setAccordion] = React.useState(0);
    const onClicked = () => {
        setAccordion(!accordionStatus)
    }

  return (
    // <div className={`${container} ${sectionFaq}`}>
        // <h2 className={textCenter}>Frequently Asked Questions</h2>
        <div className={`${accordion} ${accordionStatus ? uncollapsed : collapsed}`}>
            <button onClick={onClicked}>
                {questions}
                <span className={arrow}></span>    
            </button>
            <div className={accordionPanel}>
                <div className={padB30}>
                    {answers}
                </div>
            </div>
        </div>
//    </div>
  );
};

export default Faqs;
